module.exports = __webpack_public_path__ + "img/9.dd98541b.jpg";